import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../../data/faqs';
import { CheckoutButton } from '../CheckoutButton';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-sand-50 px-4 py-14 sm:py-20" data-id="element-140" data-mp="zp47tnde7k4a">
      <div className="mx-auto w-full max-w-2xl" data-id="element-141" data-mp="uqj3pcv0sgak">
        <div className="text-center" data-id="element-142" data-mp="usvrw7rdfmw2">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-500" data-id="element-143" data-mp="70our6dtnbvl">
            ❓ Frequently asked questions
          </p>
          <h2 className="mt-3 font-display text-[27px] font-bold leading-[1.14] tracking-tight text-navy-900 sm:text-4xl" data-id="element-144" data-mp="23yfgl9uckb8">
            Everything you might be wondering
          </h2>
        </div>

        <ul className="mt-8 space-y-2.5" data-id="element-145" data-mp="bz04lh449mdt">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy-800/8" data-id="element-146" data-mp="1nfq9mwwt085u" data-mpi={i}>
                <h3 data-id="element-147" data-mp="huincrc5v3qk">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-sand-50 sm:px-5" data-id="element-148" data-mp="hsxud65hvsut">
                    <span className="text-[14.5px] font-bold leading-snug text-navy-900 sm:text-base" data-id="element-149" data-mp="3v8m2xrvc7zyi">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-aqua-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-150" data-mp="42kjow17y01s" />
                  </button>
                </h3>
                {isOpen ? <p className="px-4 pb-4 text-[14.5px] leading-relaxed text-navy-800/72 sm:px-5" data-id="element-151" data-mp="3giy20rr2j3bb">
                    {faq.answer}
                  </p> : null}
              </li>;
        })}
        </ul>

        <div className="mt-8" data-id="element-152" data-mp="ipw8xgg79oly">
          <CheckoutButton label="I'm ready — get access now" sub="$27 · Instant access · 7-Day Guarantee" data-id="element-153" data-mp="xf2fjphdah3v" />
        </div>
      </div>
    </section>;
}